import React from 'react'
import styles from 'modules/User/Security/Security.module.scss'

export const SecurityPassword = () => (
  <div className={styles['security__password']} />
)
